<script>
    // @ts-nocheck

    import {
        Button,
        TertiaryButton,
        Typography,
        Chip,
        BackDrop,
        Spinner,
    } from '$lib/components/UI'
    import Paginator from '$lib/components/UI/Paginator.svelte'
    import Datatable from '$lib/components/UI/DatatableX.svelte'
    import FilterBoxTenders from '$lib/custom/components/FilterBoxTenders.svelte'
    import licitaciones from '$lib/services/collections/tenders'
    import {idTenderOffers, createDerived as createOfferedTenderIds} from '$lib/services/collections/offers'
    import { now } from '$lib/stores/device'
    import { default as notFoundDoc } from '../assets/pictures/f64-printer.svg'
    import { onMount } from 'svelte'
    import { derived } from 'svelte/store'
    import { getDistance } from 'geolib'
    import { Router, Route, navigate, useLocation } from 'svelte-navigator'
    import { fly } from 'svelte/transition'
    import { Licitacion as LicitacionInterface } from '$lib/services/interfaces'
    import { db } from '$lib/services/db'
    import { liveQuery } from '$lib/services/livequery'
    import {
        timeParse,
        getDiffDate,
        getDateObj,
        clickOutside,
        strftime,
        sleep,
    } from '$lib/utils'
    import Licitacion from '../views/Licitacion.svelte'
    import TopBar from '$lib/components/layout/TopBar.svelte'
    import ScrollBox from '$lib/components/UI/ScrollBox.svelte'
    import user from '$lib/stores/user'
    import dictionaries from '$lib/stores/dictionaries'
    import {
        buildFilterCompilator,
        idFilter,
    } from '$lib/services/dynamicFilters'

    let ofertable = true
    const location = useLocation()
    $: viewLicitacion = $location?.pathname?.match(/\/home\/licitaciones\/.+$/)

    let filterCompilator = buildFilterCompilator()
    onMount(() => {
        // licitaciones.sync()
    })
    const loadingStateLicitaciones = licitaciones.getLoadingState()
    const lastUpdate = licitaciones.getLastUpdateState()
    let licitacionData = {}
    const fetchLicitacion = async (id) => {
        const res = await LicitacionInterface.getById(id)
        licitacionData = await res.json()
        return licitacionData
        // return licitacionesStore.get(id, true)
    }
    const resolveLabel = (value, dict) =>
        dict?.find((x) => x.value === value)?.label || value
    // LICITACIÓN: Fecha Licitación/ Licitación  / Siniestro / Marca / Modelo /Jurisdicción-Distancia/Estado. 
    const schema = {
        fecha_licitacion: { label: 'Fecha de licitación' },
        id_licitacion: {label: 'Licitación' },
        id_siniestro: {label: 'Siniestro' },
        marca: '',
        modelo: '',
        // entrega: '',
        // sucursal: '',
        // fecha_vencimiento: {label: 'Finaliza en'},
        jurisdiccion: { label: 'Jurisdicción' },
        distancia: { ordering: false },
        estado: '',
        '': '',
    }
    let customFilters = []
    const idTenderOff = createOfferedTenderIds($user?.defaultAccount)
    // $: idsOfertas = $ofertas?.map((x) => x.id_licitacion) || []
    $: vencida = licitacionData.fecha_vencimiento
        ? getDateObj(licitacionData.fecha_vencimiento, -3).getTime() < Date.now()
        : false
    $: ofertada = $idTenderOffers?.includes(licitacionData.id_licitacion)
    $: abierta = licitacionData.state === 'Abierta'
    $: ofertable = !vencida && !ofertada && abierta
    $: compiledFilter = filterCompilator([
        [
            true,
            (items) =>
                items.filter(
                    (i) =>
                        i.cuit == $user?.defaultAccount && i.state == 'Abierta'
                ),
        ], // Que sean del proveedor y esten abiertas
        [
            true,
            (items) =>
                items.filter(
                    (i) =>
                        getDateObj(i.fecha_vencimiento, -3).getTime() > $now
                ),
        ], // Que no esten vencidas
        [
            true,
            (items) => {
                return items.filter((i) => !$idTenderOff?.includes(i.id_licitacion))
            }
        ], // Ocultar licitaciones ofertadas
        // [
        //     true,
        //     (items) =>
        //         items.filter((i) => !($ofids || [])?.includes(i.id_licitacion)),
        // ], // Ocultar licitaciones ofertadas
        ...customFilters,
    ])
    $: licitaciones.liveQuery(compiledFilter)

    let showAddOfferForm = false
    // Pagination
    let pagination = {}
    let pageSize = 15
    let currentPage = 1
    const initLicitaciones = async () => {
        return new Promise(async (res) => {
            try{licitaciones.init()} catch(e) { licitaciones.refresh() }
            if (licitaciones.length() === 0) {
                let iter = 10
                while(iter > 0) {
                    await sleep(150)
                    iter--
                    if (!$loadingStateLicitaciones) {
                        break
                    }
                }
            }
            licitaciones.refresh()
            res()
        })
    }
    $: console.log({$idTenderOff, $idTenderOffers})
</script>

<Router primary={false}>
    <Route path="">
        {#await initLicitaciones()}
            <span
                style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center"
            >
                <Spinner />
            </span>
        {:then _}
            <FilterBoxTenders bind:filters={customFilters} lastUpdate={$lastUpdate} loading={$loadingStateLicitaciones} on:runSync={() => licitaciones.sync()}/>
            <Datatable
                style="width: 100%"
                data={licitaciones}
                ordering
                {schema}
                bind:currentPage
                bind:pageSize
                bind:pagination
            >
                <svelte:fragment slot="noContent">
                    {#if $loadingStateLicitaciones}
                        <span style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center">
                            <Spinner />
                        </span>
                    {:else}
                        <img
                            src={notFoundDoc}
                            height="75px"
                            alt=""
                            style="margin: 0;padding:0; width: auto"
                        />
                        <Typography style="margin: 0; padding: 0" type="body"
                            >No se encontraron Licitaciones.</Typography
                        >
                    {/if}
                </svelte:fragment>
                <!-- LICITACIÓN: Fecha Licitación/ Licitación  / Siniestro / Marca / Modelo /Jurisdicción-Distancia/Estado -->
                <svelte:fragment slot="row" let:item={licitacion}>
                    {@const untilDate = getDateObj(
                        licitacion.fecha_vencimiento,-3
                    )}
                    {@const timeAvailable = getDiffDate(untilDate, $now)}
                    {@const state =
                        timeAvailable > 0 ? licitacion.state : 'Finalizada'}
                    <tr>
                        <td
                            >{strftime(
                                '%d/%m/%Y',
                                getDateObj(licitacion.fecha_licitacion,-3)
                            )}</td
                        >
                        <td>{String(licitacion.id_licitacion).slice(4)}</td>
                        <td>{licitacion.id_siniestro}</td>
                        <td>{licitacion.marca_vehiculo}</td>
                        <td>{licitacion.modelo_vehiculo}</td>
                        <!-- <td>{`${licitacion.demora}Hs`}</td> -->
                        <!-- <td>{licitacion.sucursal.nombre}</td> -->
                        <!-- <td>{timeAvailable > 0 ? timeParse(timeAvailable, '%H:%M:%s') : '-- : -- : --'}</td> -->
                        <td
                            >{resolveLabel(
                                licitacion.jurisdiccion,
                                $dictionaries.jurisdicciones
                            )}</td
                        >
                        <td title={`Desde sucursal "${licitacion.sucursal.nombre}"`}>
                            {#if licitacion.sucursal.ubicacion && licitacion.ubicacion}
                                {(
                                    getDistance(
                                        licitacion.sucursal.ubicacion,
                                        licitacion.ubicacion
                                            .split(',')
                                            .map((coord) =>
                                                parseFloat(coord.trim())
                                            )
                                    ) / 1000
                                ).toFixed(1)} Km
                            {:else}
                                ?
                            {/if}
                        </td>
                        <td
                            ><Chip
                                color={state === 'Finalizada'
                                    ? '--color-grey-300'
                                    : '--color-brand-primary-01'}>{state}</Chip
                            ></td
                        >
                        <td>
                            <TertiaryButton
                                disabled={state === 'Finalizada'}
                                on:click={() =>
                                    navigate(
                                        `/home/licitaciones/${licitacion.id_licitacion}/view`
                                    )}>Ver</TertiaryButton
                            >
                        </td>
                    </tr>
                </svelte:fragment>
            </Datatable>
            {#if pagination?.total > 0}
                <span
                    style="width: 100%; display: flex; flex-direction: row; justify-content: center; margin-top: 15px"
                >
                    <Paginator {...pagination} bind:currentPage />
                </span>
            {/if}
        {/await}
        <Route path="/:id_licitacion/view" let:params>
            <BackDrop
                style="z-index: 999999; position: fixed"
                bind:visible={viewLicitacion}
            >
                <div
                    class="drawer"
                    transition:fly={{ x: 50 }}
                    use:clickOutside
                    on:clickout={(_) => navigate('/home/licitaciones')}
                >
                    <TopBar
                        title="Detalle de la Licitación"
                        on:back={() => navigate('/home/licitaciones')}
                    >
                        <span slot="bar">
                            <Button
                                disabled={!ofertable}
                                on:click={() => (showAddOfferForm = true)}
                                type="transparent"
                                style="height: 45px !important; margin-right: 15px"
                                label="Ofertar"
                            />
                        </span>
                        <ScrollBox width="100%" height="calc(100% - 0px)">
                            {#await fetchLicitacion(params.id_licitacion)}
                                <span
                                    style="width: 100%; display: flex; justify-content: center; align-items: center; height: 100%; position: absolute"
                                >
                                    <Spinner />
                                </span>
                            {:then data}
                                <Licitacion
                                    bind:visible={showAddOfferForm}
                                    bind:ofertable
                                    {data}
                                />
                            {/await}
                        </ScrollBox>
                    </TopBar>
                </div>
            </BackDrop>
        </Route>
    </Route>
</Router>

<style>
    .drawer {
        position: absolute;
        min-width: 500px;
        width: 100%;
        max-width: 978px;
        right: 0;
        top: 0;
        height: 100%;
        background-color: #f6f6f6;
    }
</style>
